<!-- <div class="modal-container">
  <button
    id="modalButton"
    #modalButton
    data-bs-toggle="modal"
    data-bs-target="#modalAlerta"
    hidden="hidden">
    Launch
  </button>
  <div
    class="modal"
    id="modalAlerta"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            disabled
            class="btn-close btn-close-white"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="cancelar()"></button>
        </div>
        <div class="modal-body">
          <div class="modal-icon">
            <span
              class="govco-icon"
              [ngClass]="{
                'govco-info-circle': tipo === 'confirmacion',
                'govco-check-circle': tipo === 'exito',
                'govco-times-cancel': tipo === 'error',
                'govco-exclamation-circle': tipo === 'advertencia',
              }"></span>
          </div>
          <h3
            class="modal-title-govco"
            id="modalTitle"
            [ngClass]="{
              'confirmation-govco': tipo === 'confirmacion',
              'success-govco': tipo === 'exito',
              'error-govco': tipo === 'error',
              'warning-govco': tipo === 'advertencia',
            }">
            {{ titulo }}
          </h3>
          <p class="modal-text-govco modal-text-center-govco">
            {{ contenido }}
          </p>
        </div>
        <div class="modal-footer-govco modal-footer-alerts-govco">
          <div class="modal-buttons-govco justify-content-evenly">
            <button
              type="button"
              class="btn btn-primary btn-modal-govco"
              data-bs-dismiss="modal"
              (click)="confirmar()">
              {{ tipo === 'confirmacion' ? 'Confirmar' : 'Aceptar' }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-modal-govco btn-contorno"
              data-bs-dismiss="modal"
              (click)="cancelar()"
              *ngIf="tipo === 'confirmacion'">
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
 -->

<!-- Button trigger modal -->
<button
  id="modalButton"
  #modalButton
  data-bs-toggle="modal"
  data-bs-target="#modalAlerta"
  hidden="hidden"
  hidden
  aria-hidden="true"
  tabindex="-1">
  Launch
</button>

<!-- Modal -->
<div
  class="modal fade"
  id="modalAlerta"
  tabindex="-1"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border-0">
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="cancelar()"></button>
      </div>
      <div class="modal-body d-flex flex-column align-items-center">
        <div class="modal-icon">
          <span
            class="govco-icon"
            [ngClass]="{
              'govco-info-circle': tipo === 'confirmacion',
              'govco-check-circle': tipo === 'exito',
              'govco-times-cancel': tipo === 'error',
              'govco-exclamation-circle': tipo === 'advertencia',
            }"></span>
        </div>
        <h3
          class="modal-title-govco text-center"
          id="modalTitle"
          [ngClass]="{
            'confirmation-govco': tipo === 'confirmacion',
            'success-govco': tipo === 'exito',
            'error-govco': tipo === 'error',
            'warning-govco': tipo === 'advertencia',
          }">
          {{ titulo }}
        </h3>
        <p class="text2-tipografia-govco text-center">
          {{ contenido }}
        </p>
      </div>
      <div *ngIf="!continuar; else isContinuar">
      <div
        class="modal-footer border-0 d-flex justify-content-center align-items-center">
          <button
          type="button"
          class="btn btn-primary btn-modal-govco"
          data-bs-dismiss="modal"
          (click)="confirmar()"
          aria-label="Confirmar">
          {{ tipo === 'confirmacion' ? ("modal-alerta.confirmar" | translate) : ("modal-alerta.aceptar" | translate) }}
        </button>
        <button
          type="button"
          class="btn btn-primary btn-modal-govco btn-contorno"
          data-bs-dismiss="modal"
          (click)="cancelar()"
          *ngIf="tipo === 'confirmacion'"
          aria-label="Cancelar">
          {{"modal-alerta.cancelar" | translate}}
        </button>
      </div>
    </div>
    <ng-template #isContinuar>
      <div
      class="modal-footer border-0 d-flex justify-content-center align-items-center">
        <button
          type="button"
          class="btn btn-primary btn-modal-govco"
          data-bs-dismiss="modal"
          (click)="confirmar()"
          aria-label="Sí">
          {{"modal-alerta.si" | translate}}
        </button>
        <button
          type="button"
          class="btn btn-primary btn-modal-govco btn-contorno"
          data-bs-dismiss="modal"
          (click)="cancelar()"
          *ngIf="tipo === 'confirmacion'"
          aria-label="No">
          {{"modal-alerta.no" | translate}}
        </button>
      </div>
    </ng-template>
    </div>
  </div>
</div>
